import { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { compress, decompress } from 'lz-string';

// Общий экземпляр клиента React Query
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // Увеличиваем до 10 минут для глобальных настроек
      gcTime: 24 * 60 * 60 * 1000, // 24 часа храним в кеше (новое название для cacheTime)
      retry: 1,
      refetchOnWindowFocus: false, // Отключаем глобально - каждый хук сам решает
      refetchOnReconnect: false, // Отключаем глобально
      refetchOnMount: 'stale', // Обновляем только если данные устарели
      refetchInterval: false, // Отключаем автоматические интервалы
    },
  },
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const localStoragePersister: any = {
  persistClient: async (client: unknown) => {
    try {
      const compressed = compress(JSON.stringify(client));
      window.localStorage.setItem('reactQueryCache', compressed);
    } catch (err) {
      console.warn('PersistClient error', err);
    }
  },
  restoreClient: async () => {
    try {
      const cached = window.localStorage.getItem('reactQueryCache');
      if (!cached) return undefined;
      const decompressed = decompress(cached);
      return decompressed ? JSON.parse(decompressed) : undefined;
    } catch {
      return undefined;
    }
  },
  removeClient: async () => {
    window.localStorage.removeItem('reactQueryCache');
  },
};

// Временно отключаем персистентность кэша из-за переполнения localStorage
// persistQueryClient({
//   queryClient,
//   persister: localStoragePersister,
//   maxAge: 24 * 60 * 60 * 1000, // 24 часа
//   buster: 'v1', // Увеличивайте, если нужно сбросить кеш
// }); 